import React, {useEffect, useState, Fragment} from 'react';

import ModalContentWrapper from '../ModalContentWrapper';
import {getCustomDataFromResponse, getDataFromResponse} from "../../DataFunctions/BaseDataFns";
import {useForm} from "react-hook-form";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import SpinnerDiv from "root/Components/SpinnerDiv";
// import bootbox from "bootbox";
import PropTypes from "prop-types";
import {createNewDomain, getDomainDetails, updateDomainDetails} from "root/DataFunctions/DomainDataFns";

import DropdownOrganisations from "root/ReactHookForm/ui/DropdownOrganisations";

const ModalDomain = ({domain_id, onSaveCompleted, onClose, mode, width }) =>
{
    const [data, setData] = useState({isLoading: true, data: []});
    const isFetchRequired = mode === 'edit' || mode === 'view' || mode === 'delete';
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const submitButtonText = () => {
        switch (mode)
        {
            case 'view':
                return 'Close';
                break;

            case 'edit':
                return 'Submit';
                break;

            case 'create':
                return 'Submit';
                break;

            case 'delete':
                return 'Delete';
                break;
        }
    };

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                domain: {
                    member_organisations: null,
                    name: '',
                    description: '',
                }
            }
        });

    useEffect(() =>
    {
        if (data.isLoading === false)
        {
            setFocus("domain.name");
        }
    }, [data.isLoading]);

    const titles = {
        view: 'View Organisation Details',
        edit: 'Edit Organisation Details',
        create: 'New Organisation',
        delete: 'Delete Organisation'
    };

    useEffect(() =>
    {
        if (domain_id !== null)
        {
            getData();
        }
        else
        {
            if (mode === 'create')
            {
                setData({isLoading: false, data: []});
            }
        }

    }, []);

    const getData = () => {
        if (isFetchRequired)
        {
            getDomainDetails(domain_id, (response) =>
            {
                const domainData = getDataFromResponse(response)[0];

                const organisations = getCustomDataFromResponse( response, 'organisations') ;

                const members = organisations.map ((item) =>
                {
                    return (
                        { label: item.name, value: +(item.organisation_id) }
                    )
                });

                setValue('domain',
                    {
                        member_organisations: members,
                        name: domainData.domain_name,
                        description: domainData.domain_description,
                    });
                setData({isLoading: false, data: domainData});
            });
        }
    }

    const onClickCancel = () =>
    {
        onSaveCompleted('cancel');
        onClose();
    }

    const doCreateDomain = (formData) =>
    {
        createNewDomain(formData, (response) =>
        {
            bootbox.alert({
                size: "small",
                message: 'Domain has been Created',
                callback: (result =>
                {
                    setButtonDisabled ( false );
                    onSaveCompleted('saved');
                    onClose();
                })
            })

        });
    }

    const doUpdateDomainDetails = (formData) =>
    {
        updateDomainDetails(domain_id, formData, (response) =>
        {
            bootbox.alert({
                size: "small",
                message: 'Domain has been Updated',
                callback: (result =>
                {
                    setButtonDisabled ( false );
                    onSaveCompleted('saved');
                    onClose();
                })
            })
        });
    }

    const doDelete = (callback) =>
    {
        deleteUser(child_id, (response) =>
        {
            onSaveCompleted('saved');
            onClose();
        });
    }

    const getSubmitButtonText = (mode) =>
    {
        return submitButtonText();
    }

    const getSubmitButtonStyle = (mode) =>
    {
        switch (mode)
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small";
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small";
        }
    }

    const submitButton = (mode, onClick) =>
    {
        const clickHandler = buttonDisabled === false ? onClick : null;

        return (
            <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}}
                    disabled={buttonDisabled} className={getSubmitButtonStyle(mode)}>{getSubmitButtonText(mode)}<i
                className="et-save"/></button>
        )
    }

    const onSubmit = (data, status) => {

        setButtonDisabled ( true );

        switch (mode)
        {
            case 'create' :
                doCreateDomain(data);
                break;

            case 'edit' :
                doUpdateDomainDetails(data);
                break;

            case 'delete' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to archive this User?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doDelete();
                        }
                    })
                })
                break;
        }
    }

    const onClickSaveButton = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const Title = (props) =>
    {
        return <h3>{titles[mode]}</h3>
    }

    const isViewOnly = mode === 'view';

    const validateDropdownOrganisations = (val) =>
    {
        if (+val === 0)
        {
            return "You must select an organisation";
        }
    }

    const renderHookForm = (prop) =>
    {
        const readOnlyMode = mode === 'view' || mode === 'delete' ? 'readonly' : '';

        return (
            <Fragment>
                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Domain Name</label>
                                <input readOnly={readOnlyMode} className='form-control' name='domain.name'
                                       id='name' {...register("domain.name", {required: true})} />
                                {formErrors.domain?.name && <ErrorDiv>Please enter a name</ErrorDiv>}
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Description</label>
                                <input readOnly={readOnlyMode} className='form-control' name='domain.description'
                                       id='surname' {...register("domain.description", {required: true})} />
                                {formErrors.domain?.description && <ErrorDiv>Please enter a contact name</ErrorDiv>}
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Member Organisations</label>
                                <DropdownOrganisations readOnly={false} control={control}
                                                           mode={mode} name='domain.member_organisations'
                                                           rules={{required: true, validate: validateDropdownOrganisations}}
                                                           placeholder='Please select an organisation'
                                                           isSearchable={true}
                                                           isClearable={true}
                                                           isMulti={true}/>
                                {formErrors.domain?.member_organisations && <ErrorDiv>Please select an organisation type</ErrorDiv>}
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i
                            className="et-arrow-bold-left"/></button>
                        {!isViewOnly && submitButton(mode, onClickSaveButton)}
                    </div>
                </form>
            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={mode}/>
            <div style={{width: width}}>
                {data.isLoading && <SpinnerDiv/>}
                {!data.isLoading && renderHookForm()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalDomain;

ModalDomain.defaultProps = {
    width: '600px'
}

ModalDomain.propTypes = {
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};